export const RandomResult = ({ result }) => {
  return (
    <div className="result-area">
      <p className="title">結果</p>

      {/* 初期状態ではメッセージを表示 */}
      <h3 className="result-text">{result || "まだ結果がありません"}</h3>
    </div>
  );
};